// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".texts p{margin-bottom:10px}", "",{"version":3,"sources":["webpack://./wp-content/themes/tbbay/assets/src/js/inc/components/contactForm.vue"],"names":[],"mappings":"AAGI,SACI,kBAFR","sourcesContent":["\n.texts {\n\n    p {\n        margin-bottom: 10px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
